import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ButtonList, Container, LabelInput } from './RadioButton.styles';
import { selectInputs, setUserInputs } from '../../../redux/inputsReducer';
import Option from './Option';
import TextInput from '../TextInput/TextInput';
import { CheckBoxInputProps } from '../../../types';
import { Form } from '../../../types/analytics';
import { digitalLeadsFormInput } from '../../../utils/analyticsEventListeners';
import { INPUT_TYPE, FEATURE_APP_DETAILS } from '../../../constants';
import { convertToPromotionsType } from '../../../functions/convertToPromotionsType';
import { getVehicleForPromotions } from '../../../functions/getVehicleForPromotions';
import { selectDealerAndVehicleData } from '../../../redux/dealerAndVehicleReducer';
import { selectForm, setForm } from '../../../redux/formReducer';
import { selectAppConfig } from '../../../redux/appConfigReducer';

interface RadioButtonProps {
  title: string;
  inputKey: string;
  options: CheckBoxInputProps;
}
const RadioButtonInput: React.FC<RadioButtonProps> = ({ title, inputKey, options }) => {
  const { vehicle } = useSelector(selectDealerAndVehicleData);
  const contactForm = useSelector(selectForm);
  const dispatch = useDispatch();
  const { preferredContactMethod } = useSelector(selectInputs);

  const { offers } = useSelector(selectAppConfig);
  const promotion = convertToPromotionsType(offers!);

  let vehicleData = vehicle;

  if (!vehicle && offers) {
    vehicleData = getVehicleForPromotions(offers);
  }

  const onHandleChange = (value: string) => {
    const inputTouched = {
      inputTitle: inputKey,
      inputValue: value,
      action: 'select',
      inputType: 'radio',
    };

    const updatedForm: Form = {
      ...contactForm,
      ...{ formData: { ...contactForm.formData, ...{ preferredContactMethod: value } } },
    };

    dispatch(setForm(updatedForm));
    dispatch(setUserInputs({ inputName: inputKey, inputValue: value }));
    digitalLeadsFormInput(updatedForm, vehicleData, FEATURE_APP_DETAILS, promotion, inputTouched);
  };

  const listOfOptions = Object.keys(options);
  return (
    <Container data-testid="radio-button-wrapper">
      <LabelInput>{title}</LabelInput>
      <ButtonList>
        {listOfOptions.map((option) => {
          const { value, key } = options[option];
          const checked = preferredContactMethod === value;
          return (
            <Option
              {...options[option]}
              name={inputKey}
              onChange={onHandleChange}
              checked={checked}
              key={key}
            />
          );
        })}
      </ButtonList>
      {preferredContactMethod !== INPUT_TYPE.EMAIL && (
        <TextInput
          inputLabel="Enter your phone number *"
          inputKey={INPUT_TYPE.PHONE}
          inputType="text"
        />
      )}
    </Container>
  );
};

export default RadioButtonInput;
